import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  padding-top: 0.5rem;
`;

export const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const RightWrapper = styled.div`
  display: flex;
  align-items: end;
`;

export const ApneaScoreValue = styled.span`
  color: ${props => props.color};
  margin-bottom: 0rem;
`;
